import Alpine from 'alpinejs';

/**
 * Register the canvasOverlay Alpine store.
 * Must be set up before Alpine.start() is called (via the alpine:init event).
 */
document.addEventListener( 'alpine:init', () => {
	Alpine.store( 'canvasOverlay', {
		open: false,

		show() {
			this.open = true;
			document.body.style.overflow = 'hidden';
		},

		hide() {
			this.open = false;
			document.body.style.overflow = '';
		},
	} );

	Alpine.store( 'mobileMenu', {
		open: false,

		show() {
			this.open = true;
			document.body.style.overflow = 'hidden';
		},

		hide() {
			this.open = false;
			document.body.style.overflow = '';
		},
	} );
} );

/**
 * Open the overlay when any link with href="#subsidie-aanvragen" is clicked.
 * Works for links in the navigation, pages, posts, or anywhere in the content.
 * Attached directly (no DOMContentLoaded wrapper) so it works even when the
 * script is loaded with defer or as a module.
 */
document.addEventListener( 'click', ( e ) => {
	const link = e.target.closest( 'a[href="#subsidie-aanvragen"]' );

	if ( ! link ) {
		return;
	}

	e.preventDefault();
	Alpine.store( 'canvasOverlay' ).show();
} );
